export const expectedUserProvisioningErrorSubstrings: Record<string, string> = {
  PendingUser: 'BootstrapError: PendingUser',
  UnlicensedUser: 'BootstrapError: UnlicensedUser',
};

export const BackgroundLoadNotEnabledErrorMessage = 'BackgroundLoadNotEnabled';
